import Stepper from "../components/Stepper/Stepper";

export default function AddResidentPage() {
  return <Stepper />;
}
